import http from "../core/api/httpClient";

const normalizeOptional = (value?: string | null) => {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
};

export interface LeadQualifyingQuestionsResponse {
  lead_id: string;
  lead_number: string;
  first_name: string;
  last_name: string;
  email: string;
  current_visa: string | null;
  timeline: string | null;
  goals: string | null;
  location: string | null;
  submitted: boolean;
  submitted_at: string | null;
  updated_at: string;
}

export interface LeadQualifyingQuestionsPayload {
  current_visa: string;
  timeline: string;
  goals: string;
  location: string;
}

export const qualifyingQuestionsService = {
  async getLeadQualifyingQuestions(leadId: string): Promise<LeadQualifyingQuestionsResponse> {
    const response = await http.get<LeadQualifyingQuestionsResponse>(
      `/leads/${leadId}/qualifying-questions`
    );
    return response.data;
  },

  async submitLeadQualifyingQuestions(
    leadId: string,
    payload: LeadQualifyingQuestionsPayload
  ): Promise<LeadQualifyingQuestionsResponse> {
    const response = await http.post<LeadQualifyingQuestionsResponse>(
      `/leads/${leadId}/qualifying-questions`,
      {
        current_visa: normalizeOptional(payload.current_visa),
        timeline: normalizeOptional(payload.timeline),
        goals: normalizeOptional(payload.goals),
        location: normalizeOptional(payload.location),
      }
    );
    return response.data;
  },
};
